import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../constants/text';
import { smallerThan } from '../../../../core/util/styledComponents';

const NameContainer = styled.h1`
  color: ${colors.squid};
  max-width: 512px;
  font-size: ${fontSize.damnLarge};
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;

  ${smallerThan.md`
    font-size: ${fontSize.quiteExtraExtraLarge};
    text-align: center;
    margin: auto;
  `};
`;

const PrimaryName = styled.label`
  font-family: ${fontFamily.bold};
`;

const SecondaryName = styled.label`
  font-family: ${fontFamily.book};

  &:before {
    content: ', ';
  }

  ${smallerThan.md`
    display: block;

    &:before {
      content: '';
    }
  `};
`;

class ClinicName extends PureComponent {
  render = () => {
    const { primaryName, secondaryName, alternateName, className } = this.props;

    return (
      <NameContainer id="nameContainer" className={className}>
        <Fragment>
          <meta
            itemProp="name"
            content={`${primaryName} ${secondaryName ? `, ${secondaryName}` : ''}`}
          />
          {alternateName && <meta itemProp="alternateName" content={alternateName} />}
          <PrimaryName>{primaryName}</PrimaryName>
          {secondaryName && <SecondaryName>{secondaryName}</SecondaryName>}
        </Fragment>
      </NameContainer>
    );
  };
}

ClinicName.propTypes = {
  primaryName: PropTypes.string.isRequired,
  secondaryName: PropTypes.string,
  alternateName: PropTypes.string,
  className: PropTypes.string,
};

export default ClinicName;
